import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'usehooks-ts';

import { useParseParams } from '@hooks/params';
import { comparePersonalAccidentQuoteParamsSchema } from '@apis/PersonalAccidentQuoteApi';

import { selectPersonalAccidentQuoteComparePage } from './selector';
import { personalAccidentQuotesFetch, PersonalAccidentQuotesFetchPayload } from './action';
import { PersonalAccidentQuoteComparePageParams } from './route';

export const usePersonalAccidentQuotesComparePageParams = () =>
  useParseParams<PersonalAccidentQuoteComparePageParams>(comparePersonalAccidentQuoteParamsSchema);

export const usePersonalAccidentQuotesFetch = () => {
  const dispatch = useDispatch();
  const params = usePersonalAccidentQuotesComparePageParams();
  const { personalAccidentQuotes } = useSelector(selectPersonalAccidentQuoteComparePage);

  useEffectOnce(() => {
    const payload: PersonalAccidentQuotesFetchPayload = params;
    dispatch(personalAccidentQuotesFetch(payload));
  });

  return personalAccidentQuotes;
};
